// Shortcut help overlay toggled by `?` (see `registerEscHandler` in
// functions/index.js). Centered modal-style card listing every
// marketplace keyboard shortcut. Click the backdrop or press Esc to
// close — Esc priority is handled in the global keydown listener so
// it beats the detail-pane Esc close when both are open.

const SHORTCUTS = [
  { keys: '/', label: 'Focus search' },
  { keys: '⌘ K / Ctrl+K', label: 'Focus search' },
  { keys: 'Tab / Shift+Tab', label: 'Move between cards' },
  { keys: 'Enter / Space', label: 'Open focused item' },
  { keys: '⌘ Enter / Ctrl+Enter', label: 'Install / Configure open item' },
  { keys: 'R', label: 'Surprise me — open a random visible item' },
  { keys: 'P', label: 'Toggle pin on open detail' },
  { keys: 'S', label: 'Copy shareable URL to clipboard' },
  { keys: 'Esc', label: 'Close this help, then detail pane' },
  { keys: '?', label: 'Toggle this help' }
]

export const MarketplaceShortcutsOverlay = {
  hide: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return !host?.shortcutsOpen
  },
  // Fixed over the whole marketplace host so it floats above every
  // sibling — Island declares `position: relative` for the toast
  // already; the overlay uses absolute to match it but sizes to the
  // full host via inset 0.
  position: 'absolute',
  inset: '0',
  zIndex: '20',
  align: 'center center',
  background: 'black.55',
  backdropFilter: 'blur(4px)',

  // Click the backdrop (but not the inner card) to close.
  onClick: (e, el) => {
    if (e.target !== el.node) return
    const host = el.call('marketplaceHostOf', el)
    host?.update?.({ shortcutsOpen: false })
  },

  ShortcutsCard: {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    minWidth: 'H',
    maxWidth: 'I',
    borderRadius: 'A',
    background: 'dialog',
    border: '1px solid line',
    boxShadow: '0 A B black.35',

    CardTitle: {
      tag: 'h3',
      text: 'Keyboard shortcuts',
      fontSize: 'B',
      fontWeight: '700',
      color: 'title',
      margin: '0'
    },

    ShortcutsList: {
      flow: 'y',
      gap: 'Z',
      childExtends: 'MarketplaceShortcutsRow',
      children: SHORTCUTS
    },

    CloseHint: {
      tag: 'p',
      text: 'Press Esc or ? to close.',
      fontSize: 'Y',
      color: 'caption',
      margin: '0'
    }
  }
}

// Each row in the list — key combo on the left, description on the
// right. Flat catalog-style children pattern so the parent's
// `children: SHORTCUTS` spreads keys + label directly onto the row.
export const MarketplaceShortcutsRow = {
  flow: 'x',
  align: 'center space-between',
  gap: 'A',

  KeyCombo: {
    tag: 'span',
    text: (el) => el.parent.keys,
    padding: 'X Z',
    borderRadius: 'Y',
    background: 'line',
    color: 'title',
    fontSize: 'Y',
    fontWeight: '600',
    whiteSpace: 'nowrap'
  },

  RowLabel: {
    tag: 'span',
    text: (el) => el.parent.label,
    fontSize: 'Y',
    color: 'paragraph',
    flex: '1',
    textAlign: 'right'
  }
}
